import { render, staticRenderFns } from "./ManagementForm.vue?vue&type=template&id=1d0d1747&"
import script from "./ManagementForm.vue?vue&type=script&lang=ts&"
export * from "./ManagementForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports